"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_APPLY = exports.Headers = void 0;
var Headers;
(function (Headers) {
    Headers["X_SITE_ID"] = "X-Site-Id";
    Headers["X_PLATFORM_ID"] = "X-Platform-Id";
    Headers["X_CLIENT_TYPE"] = "X-Client-Type";
    Headers["X_SOURCE"] = "X-Source";
    Headers["X_CONTEXTUAL"] = "X-Contextual";
    Headers["CONTENT_TYPE"] = "Content-Type";
    Headers["X_USER_AGENT"] = "X-User-Agent";
})(Headers || (exports.Headers = Headers = {}));
exports.NOT_APPLY = 'not_apply';
